/**
 * Copyright Mántum All Rights Reserved.
 */
export const KEY_CLOSE = 'close';
export const KEY_CONNECTED = 'connected';
export const KEY_DETAIL = 'detail';
export const KEY_ERROR = 'error';
export const KEY_LABEL = 'label';
export const KEY_TYPE = 'type';
export const KEY_VALUE = 'value';
export const KEY_SIMPLE = 'simple';
export const KEY_ORIGINAL = 'original';
export const KEY_STABLE_WEIGHING = 'stableWeighing';
export const KEY_SOCKET_ADDRESS = 'socketAddress';
export const KEY_SOCKET_PORT = 'socketPort';
export const KEY_ERROR_STATUS = 'Error';
export const KEY_WARNING_STATUS = 'Warning';
export const KEY_SUCCESS_STATUS = 'Success';
